import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';
import {
    SmSigningProcessObjectComponent
} from '../../component/object-components/sm-signing-process-object/sm-signing-process-object.component';

@Injectable({
    providedIn: 'root'
})
export class SmSigningProcessService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        // The GENERIC route, not the workflow route. /mvsa/sm/signingProcesses is served by
        // SmSigningProcessCrudController and therefore answers with the platform `form` object that
        // MvsCrudService consumers and every generic widget expect; the custom /mvsa/sm/signing/processes
        // answers with SmSigningProcessResponseDto and no form.
        //
        // This service is MASTER DATA ONLY (get / list / read). Every workflow verb - dispatch, sign,
        // cancel, complete, reissue-link, qr-code, layout, placements - stays on SmSigningApiService,
        // which keeps its own baseUrl on '/sm/signing'. The generic route refuses all six mutating verbs
        // by name, so nothing here may be „upgraded“ into a write path.
        super(http, MvsCrudService.baseUrl + '/sm/signingProcesses');
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode !== MvsCrudModeEnum.create) {
            return SmSigningProcessObjectComponent;
        }
        return null;
    }
}
